import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa'; // Import icons
import './Footer.css'; // We will create this file next

const Footer = ({ onNewsletterClick }) => {
    return (
        <footer className="footer">
            <div className="footer-container container">
                <div className="footer-section about-section">
                    <h3 className="footer-heading">Ummeed ki kiran foundation Trust</h3>
                    <p>
                        Dedicated to creating a safe, healthy, and nurturing environment for every child, empowering them to thrive.
                    </p>
                </div>

                <div className="footer-section links-section">
                    <h3 className="footer-heading">Quick Links</h3>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/mission">Our Mission</Link></li>
                        <li><Link to="/events">Events</Link></li>
                        <li><Link to="/donate">Donate</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/refund-policy">Refund Policy</Link></li>
                        <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                        <li>
                            <button
                                onClick={onNewsletterClick}
                                className="footer-newsletter-link"
                            >
                                📰 Newsletter
                            </button>
                        </li>
                        {/* <li><Link to="/contact">Contact Us</Link></li> Add later if needed */}
                    </ul>
                </div>

                <div className="footer-section contact-section">
                    <h3 className="footer-heading">Contact Us</h3>
                    {/* Placeholder contact info, replace with actual details from info.md or web search */}
                    <p>S 17/314 D-15, Charan Nagar Colony Nadesar, Uttar Pradesh, India</p>
                    <p>Email: <a href="mailto:support@ummeedkikiran.org">support@ummeedkikiran.org</a></p>
                    <p>Phone: <a href="tel:+917985947303">+917985947303</a></p>
                </div>

                {/* Optional: Social Media Links Section */}
                <div className="footer-section social-media-section">
                    <h3 className="footer-heading">Follow Us</h3>
                    <div className="social-icons">
                        {/* Commented out - no Facebook page available */}
                        {/* <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon social-icon-facebook"><FaFacebookF /></a> */}
                        {/* Commented out - no Twitter page available */}
                        {/* <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="social-icon social-icon-twitter"><FaTwitter /></a> */}
                        <a href="https://www.instagram.com/ummeedkikiranfoundation?igsh=bjRqanpzenVsNjht" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon social-icon-instagram"><FaInstagram /></a>
                        {/* Example for LinkedIn if needed later */}
                        {/* <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-icon social-icon-linkedin"><FaLinkedinIn /></a> */}
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Ummeed ki kiran foundation Trust. All Rights Reserved.</p>
                <p>
                    <Link to="/privacy-policy" className="footer-bottom-link">Privacy Policy</Link>
                    {" | "}
                    <Link to="/refund-policy" className="footer-bottom-link">Refund Policy</Link>
                    {" | "}
                    <Link to="/terms-conditions" className="footer-bottom-link">Terms & Conditions</Link>
                </p>
            </div>
        </footer>
    );
};

export default Footer;